import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['fileField', 'uploadButton', 'uploadButtonArea',
                    'fileNameLabel', 'deleteFileButton', 'fileArea',
                    'submitButton', 'amountField']
  static values = { pending: Number }

  connect() {
    this.setupInputs()
  }

  setupInputs() {
    this.fileFieldTarget.addEventListener('change', event => {
      event.preventDefault()
      this.handleUpload(this.fileFieldTarget.files[0])
    })
    this.deleteFileButtonTarget.addEventListener('click', event => {
      event.preventDefault()
      this.deleteImage()
    })
  }

  openExplorer(event) {
    event.preventDefault()
    this.fileFieldTarget.click()
  }

  handleUpload(file) {
    if(!file) return

    this.fileAreaTarget.classList.remove('d-none')
    this.fileNameLabelTarget.textContent = file.name
    this.uploadButtonAreaTarget.classList.add('d-none')
    this.validateForm()
  }

  deleteImage() {
    this.fileFieldTarget.value = null
    this.fileAreaTarget.classList.add('d-none')
    this.uploadButtonAreaTarget.classList.remove('d-none')
    this.validateForm()
  }

  validateForm() {
    if(!this.validForm()) {
      this.submitButtonTarget.disabled = true
    } else {
      this.submitButtonTarget.disabled = false
    }

  }

  // Un monto mayor a lo pendiente suele ser el mismo pago capturado dos veces.
  confirmExcess(event) {
    if(!this.hasPendingValue) return

    const amount = parseFloat(this.amountFieldTarget.value.replace(/[^\d.]/g, '')) || 0
    if(amount <= this.pendingValue) return

    const pending = this.pendingValue.toLocaleString('es-MX', { minimumFractionDigits: 2 })
    const message = `El monto rebasa lo pendiente del pago inicial ($${pending}). ` +
                    '¿Seguro que quieres guardar este comprobante?'
    if(!window.confirm(message)) {
      event.preventDefault()
      event.stopImmediatePropagation()
    }
  }

  validForm() {
    return this.fileFieldTarget.files.length > 0
  }
}
